import styled from 'styled-components'

export const Section = styled.section`
  padding: 2rem 0;
  width: 90vw;
  margin: 0 auto;
`
